import React from "react";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { IAdjustment2SearchParam } from "../../../Interfaces/deltaHedgeAdjustment";
import { CommonTableUI } from "../../TableTemplate/common";
import { getReferenceTable } from "../../../Requests/deltaHedgeAdjustment";
// Local Component
import { Additional } from "./Additional/Additional";

interface IProps {
  searchParams: IAdjustment2SearchParam;
}

const ReferenceTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IAdjustment2SearchParam, any>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[400px] !max-w-full overflow-x-auto order-table"
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getReferenceTable}
      searchParameters={searchParams}
      withSort
      refreshTableTime={5000}
      tableWrapperClassname="!mx-0"
    />
  );
};

export default ReferenceTable;
